import React, { useContext } from 'react';
import { navigate } from '@reach/router';
import styled from 'styled-components/macro';
import { RouteComponentProps } from '../../helpers/RouteComponentProps';
import { PageContainer } from '../../layout/Layout';
import { PrimaryButton } from '../../shared/Button';
import { Header1 } from '../../shared/Headers';
import { spacing02, spacing05 } from '../../styling/spacing';
import { getHandoverPackDocumentFromDocumentResponse } from '../shared/handover-pack/handoverPackResponse';
import { HandoverPackSectionDetails } from '../shared/handover-pack/HandoverPackSectionDetails';
import { DocumentListFilters } from './DocumentListFilters';
import { createDocumentUrl, handoverPackSectionsRoot } from './documents-section/documentRoutes';
import { HandoverPackSectionContext } from './documents-section/HandoverPackSectionContext';

type DocumentListComponent = (props: RouteComponentProps) => JSX.Element | null;

export const DocumentList: DocumentListComponent = () => {
  const { refreshContext } = useContext(HandoverPackSectionContext);

  return (
    <PageContainer>
      <HeaderRow>
        <Header1>Document Management</Header1>
        <ButtonRow>
          <PrimaryButton onClick={() => navigate(handoverPackSectionsRoot)}>Configure Sections</PrimaryButton>
          <PrimaryButton onClick={() => navigate(createDocumentUrl)}>Create New Document</PrimaryButton>
        </ButtonRow>
      </HeaderRow>
      <DocumentListFilters>
        {({ filteredDocumentSections }) =>
          filteredDocumentSections.length === 0 ? (
            <p>No documents match filter conditions</p>
          ) : (
            <>
              {filteredDocumentSections
                .filter(section => section.documents.length > 0)
                .map(section => (
                  <HandoverPackSectionDetails
                    section={{
                      ...section,
                      handoverPackDocuments: section.documents.map(document =>
                        getHandoverPackDocumentFromDocumentResponse(document),
                      ),
                    }}
                    showMenu
                    refreshContext={refreshContext}
                  />
                ))}
            </>
          )
        }
      </DocumentListFilters>
    </PageContainer>
  );
};

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing05};
`;

const ButtonRow = styled.div`
  display: flex;
  width: fit-content;
  gap: ${spacing02};
`;
